document.addEventListener("DOMContentLoaded", function () {
  //the CTA button on the mw-drinks page. bail if it isn't there
  const btn = document.getElementById("mwDrinksCta");
  if (!btn) return;

  //get all url params from this page's own url
  const params = new URLSearchParams(window.location.search);

  //carry every param through to the collection link on moonwlkr
  const url = new URL(btn.href);
  params.forEach(function (v, k) {
    if (v) url.searchParams.set(k, v);
  });

  btn.href = url.toString();
});
